import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Calculator from "../../components/Calculator";
import CalculatorNew from "../../components/CalculatorNew";
import CalculatorRemainder from "../../components/CalculatorRemainder";
import CalculatorFractions from "../../components/FractionsCalculator";
import useTopicQuestions from "../../hooks/useTopicQuestionsNew";
import { Scale } from 'react-scaling';
import DotArrayImage from "../../assets/Geometry/Shapes/Circlecirc.png";
import { render } from "react-dom";

//NEW CSV STUFF
import Papa from "papaparse";
import year1extraquestions from '../../assets/Multiplication/ExtraQuestions/mult_extraquestions.csv';
import { QuestionAnswerOutlined } from "@material-ui/icons";

let image;
var currQuestion;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = -1;
var questionCounter = 0;
var nextQuestion;
var showHideText = "Show Dot Array";


function ShuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

function GenerateUniqueRandom(min, max, notthisArray) {
    var returnMe = Math.floor(Math.random() * (max - min) + min);
    console.log(notthisArray)
  
    if (notthisArray.includes(returnMe)) {
      return GenerateUniqueRandom(min, max, notthisArray);
    }
  
    return returnMe;
  }
  
  function GenerateRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

function getAnswer(calculation) {
    const calculationParts = calculation;

    if (calculationParts.length === 3) {
        const [number1, operator, number2] = calculationParts;

        switch (operator) {
            case "÷":
                return number1 / number2;
            case "x":
                return number1 * number2;
            default:
                break;
        }
    } else if (calculationParts.length === 5) {
        let number1 = calculationParts[0];
        let number2 = calculationParts[2];
        let number3 = calculationParts[4];
        return number1 * number2 * number3;
    } else {
        return 0;
    }
}

export default function Practice({ ...props }) {
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [addedExtraQuestions, setAddedExtraQuestions] = useState(false);
    const [dotArrayOpen, setDotArrayOpen] = useState(false)
    console.log(props.topics);
    console.log(props.gameType);
    const {loadedquestions, status} = useTopicQuestions({
        topics: props.topics,
        game_type: props.gameType
    });
    const [waitTime, setWaitTime] = useState(-10);

    const [reducedQuestions, setReducedQuestions] = useState(null);
    const [questions, setQuestions] = useState(null);

    const [qImage, setQImage] = useState("");
  const [qHTML, setQuestionHTML] = useState("");
  const[showColouredFeedback, setColouredFeedback] = useState(false);

    var timer = -1;
    if(props.timelimit > 0)
    {
        timer = props.timelimit;
    }
    else
    {
        timer = 60;
    }

    var questionMax = -1;
    if(props.minimum > 0)
    {
        questionMax = props.minimum;
    }
    //if current quesiton is same as the previous question then reloop -refeed 
    if(questionCounter > 3){
      questionCounter = 0;
    }

    function GetImage(image){
        return '/qimages/' + image+".png";
    }

    function AddExtraQuestions(){
        console.log("Adding Extra Questions");
        console.log(year1extraquestions);
        console.log(loadedquestions);
        //import from CSV
        Papa.parse(year1extraquestions, {
          download: true,
          header: true,
          complete: function (results) {
            console.log("Extra Questions:");
            console.log(results.data)
            console.log(loadedquestions);
            console.log(status);
            let addMe = [];
            //check set topics and see if in extra questions
            for (let i = 0; i < props.topicKeys.length; i++) {
              const topicKey = props.topicKeys[i];
              console.log(topicKey);
              for (let x = 0; x < results.data.length; x++) {
                const extraQ = results.data[x];
                //console.log(extraQ);
                if (extraQ.topic_key == topicKey){
                  console.log("found you")
                  //make the calculation here
                  extraQ.calculation = extraQ.questionline1.split(" ");
                  extraQ.question = extraQ.questionline1;
                  extraQ.answer = extraQ.correct_answer;
                  extraQ.correct = extraQ.correct_answer;
                  extraQ.version = "new";
                  extraQ.type = "NP";
                  if (extraQ.image_type == "Remainder"){
                    extraQ.type ="NPR";
                  }
                  if (extraQ.image_type == "Part Whole"){
                    var qhtml = "<div>";
                    qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:47%'>" + extraQ.value_for_images_3 + "</b>";
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + extraQ.value_for_images_2 + "</b>"
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:15%'>" + extraQ.value_for_images + "</b>"
                    qhtml+= "</div>"
                    extraQ.questionHTML = qhtml;
                  }
                  if (extraQ.topic_key == "multdiv2Sp2S06"){
                    //CENTER THIS
                    qhtml = "<div style='width: 1000px; height: 1000px;'>";
                    qhtml+= '<img src="' + GetImage("mult/" + extraQ.value_for_images) + '"' + "style='position:absolute ; top: 10%; right:-50% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }
                  if (extraQ.topic_key == "multdiv2Sp2S08"){
                    //CENTER THIS
                    qhtml = "<div style='width: 1000px; height: 1000px;'>";
                    qhtml+= '<img src="' + GetImage("mult/" + extraQ.value_for_images) + '"' + "style='position:absolute ; top: 10%; right:-5% ; zIndex:-1;transform: scale(0.5,0.5)'" + '></img>';
                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }
                  if (extraQ.topic_key == "multdiv2Sp2S01"){//GEM BOXES
                    console.log("equal groups");
                    qhtml = "<div style='width: 500px; height: 600px;'>";
                    var startRight = -50;
                    var rightPos = 25;
                    var topPos = 0;
                    var rowCount = 1;

                    for (let i = 0; i < parseInt(extraQ.correct_answer); i++) {

                        qhtml+= '<img src="' + GetImage("mult/" + extraQ.value_for_images_2 + " gems") + '"' + "style='position:absolute ; top: "+topPos+"%;right:"+ (startRight + (rightPos*rowCount)).toString()+"% ; zIndex:-1;transform: scale(0.3,0.3)'" + '></img>';
                        rowCount++;
                        if (rowCount > 3){
                            rowCount = 1;
                            topPos+= 20;
                            rightPos = 25;
                        }
                    }

                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }

                  if (extraQ.topic_key == "multdiv2Sp2S02"){//GEM BOXES 2
                    console.log("equal groups");
                    qhtml = "<div style='width: 500px; height: 600px;'>";
                    var startRight = -50;
                    var rightPos = 25;
                    var topPos = 0;
                    var rowCount = 1;

                    for (let i = 0; i < parseInt(extraQ.value_for_images_3); i++) {

                        qhtml+= '<img src="' + GetImage("mult/" + extraQ.correct_answer + " gems") + '"' + "style='position:absolute ; top: "+topPos+"%;right:"+ (startRight + (rightPos*rowCount)).toString()+"% ; zIndex:-1;transform: scale(0.3,0.3)'" + '></img>';
                        rowCount++;
                        if (rowCount > 3){
                            rowCount = 1;
                            topPos+= 20;
                            rightPos = 25;
                        }
                    }

                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }

                  if (extraQ.topic_key == "multdiv2Sp2S03"){//GEM BOXES 3
                    console.log("equal groups");
                    qhtml = "<div style='width: 500px; height: 600px;'>";
                    var startRight = -50;
                    var rightPos = 25;
                    var topPos = 0;
                    var rowCount = 1;

                    for (let i = 0; i < parseInt(extraQ.value_for_images_3); i++) {

                        qhtml+= '<img src="' + GetImage("mult/" + extraQ.value_for_images_2 + " gems") + '"' + "style='position:absolute ; top: "+topPos+"%;right:"+ (startRight + (rightPos*rowCount)).toString()+"% ; zIndex:-1;transform: scale(0.3,0.3)'" + '></img>';
                        rowCount++;
                        if (rowCount > 3){
                            rowCount = 1;
                            topPos+= 20;
                            rightPos = 25;
                        }
                    }

                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }

                  if (extraQ.topic_key == "multdiv33S01"){
                    console.log("equal groups");
                    qhtml = "<div style='width: 500px; height: 600px;'>";
                    var startRight = -50;
                    var rightPos = 25;
                    var topPos = 0;
                    var rowCount = 1;

                    for (let i = 0; i < parseInt(extraQ.value_for_images.replace(/\s/g, "")); i++) {

                        qhtml+= '<img src="' + GetImage("mult/" + extraQ.value_for_images_2.replace(/\s/g, "") + " gems") + '"' + "style='position:absolute ; top: "+topPos+"%;right:"+ (startRight + (rightPos*rowCount)).toString()+"% ; zIndex:-1;transform: scale(0.3,0.3)'" + '></img>';
                        rowCount++;
                        if (rowCount > 3){
                            rowCount = 1;
                            topPos+= 20;
                            rightPos = 25;
                        }
                    }

                    qhtml+= '</div>';
                    extraQ.questionHTML = qhtml;
                  }

                  if (extraQ.topic_key == "multdiv33S03" || extraQ.topic_key == "multdiv33S04"){
                    qhtml = "<div>";
                    qhtml+= '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:10px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:46% ; right:300px'>" + extraQ.value_for_images + "</b>";
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:46% ; right:175px'>" + extraQ.value_for_images_2 + "</b>"
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:46% ; right:50px'>" + extraQ.value_for_images_3 + "</b>"
                    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-75px'>" + extraQ.value_for_images_4 + "</b>"
                    qhtml+= "</div>"
                    extraQ.questionHTML = qhtml;

                  }

                  //check if multiple choice
                  if (extraQ.incorrect_answer_1 != "" &&  extraQ.incorrect_answer_1 != undefined){
                    var qanswers = [];
                    //multichoice
                    extraQ.type = "MC";
                    //add answers
                    qanswers.push({correct: true, value: extraQ.correct_answer});
                    qanswers.push({correct: false, value: extraQ.incorrect_answer_1});
                    if (extraQ.incorrect_answer_2 != "" && extraQ.incorrect_answer_2 != undefined){
                      qanswers.push({correct: false, value: extraQ.incorrect_answer_2});
                    }
                    if (extraQ.incorrect_answer_3 != "" && extraQ.incorrect_answer_3 != undefined){
                      qanswers.push({correct: false, value: extraQ.incorrect_answer_3});
                    }
                    ShuffleArray(qanswers);
                    extraQ.answers = qanswers;
                    console.log(extraQ);
                  }
                  //then do special mode for remainder mode

                  addMe.push(extraQ);
                }
              }
            }

            console.log("adding regular questions");
            console.log(reducedQuestions);
            if (reducedQuestions != null){
              //if already loaded
              console.log("add loaded questions");
              for (let i = 0; i < reducedQuestions.length; i++) {
                const loadedquesiton = reducedQuestions[i];
                addMe.push(loadedquesiton);
              }
          }
            console.log("ALLQUESTIONS:");
            console.log(addMe);
            setAddedExtraQuestions(true);
            setQuestions(addMe);
            console.log("done adding extra questions");
          },
        });
        
        
      }
  

    useEffect(() => {
        if (status !== undefined && status === "OK") {
                setLoading(false);
                //AddExtraQuestions();
            }
      }, [status]);


      useEffect(() => {
        if (reducedQuestions != null){
            AddExtraQuestions();
        }
        
      }, [reducedQuestions])

    console.log(props);

    useEffect(() => {
        console.log(loadedquestions);
        if (loadedquestions && loadedquestions.length > 0) {
            //process questions
            setReducedQuestions(loadedquestions.reduce((acc, gcalc) => {
                let calc = gcalc.example_question.split(" ");
                for (var i = 1; i < 12; i++) {
                    let generatedCalculation = [];
                    // check that the calculation is [number1 , operator, number2] (eg 1 x 2)
                    if (calc.length === 3) {
                        const number2 = parseInt(calc[2]);
                        const number1 = calc[1] === "÷" ? i * number2 : i;
                        generatedCalculation[0] = number1;
                        generatedCalculation[1] = calc[1];
                        generatedCalculation[2] = number2;
                    } else if (calc.length === 5) {
                        // if got length of 5 then we expect [number1 , operator, number2, operator, number3] (eg. a x b x c) and need to generate a random number for each part of the calulation
                        const number1 = Math.floor(Math.random() * 9 + 1);
                        const number2 = Math.floor(Math.random() * 9 + 1);
                        const number3 = Math.floor(Math.random() * 9 + 1);
                        const operator = "x";

                        generatedCalculation[0] = number1;
                        generatedCalculation[1] = operator;
                        generatedCalculation[2] = number2;
                        generatedCalculation[3] = operator;
                        generatedCalculation[4] = number3;
                    }
                    console.log("CALC");
                    console.log(gcalc.topic_key);

                    if (gcalc.topic_key == "multiple10"){//times by multiple of 10
                        let num1 = GenerateRandom(1,99);
                        var num2array = [10,100,1000];
                        var num2 = num2array[GenerateRandom(0, num2array.length)];
                        const operator = "x";
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = operator;
                        generatedCalculation[2] = num2;
                    }
                    if (gcalc.topic_key == "multiple10+1"){//times by multiple of 10
                        let num1 = GenerateRandom(1,99);
                        var num2array = [9,99,999,11,101,1001];
                        var num2 = num2array[GenerateRandom(0, num2array.length)];
                        const operator = "x";
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = operator;
                        generatedCalculation[2] = num2;
                    }
                    if (gcalc.topic_key == "dec"){//times by decimal
                        //generate answer first and then work backwards
                        var num2array = [10,100,1000];
                        var num2 = num2array[GenerateRandom(0, num2array.length)];
                        let ans = 0;
                        if (num2 == 10){
                            ans = GenerateRandom(1,10)
                        }
                        if (num2 == 100){
                            ans = GenerateRandom(11,100)
                        }
                        if (num2 == 1000){
                            ans = GenerateRandom(101,1000)
                        }
                        let num1 = ans / num2;
                        const operator = "x";
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = operator;
                        generatedCalculation[2] = num2;
                        ans = Math.trunc(ans);
                    }
                    if (gcalc.topic_key == "cubes"){//cube a number
                        var override = "cubes";
                        var num1 = GenerateRandom(1,10);
                        const operator = "^";
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = "³";
                        var ans = num1*num1*num1;
                    }
                    if (gcalc.topic_key == "multorder"){//multiplication order
                        var override = "multorder";
                        var num1 = GenerateRandom(1,10);
                        var num2 = GenerateRandom(2,10);
                        var num3 = GenerateRandom(1,num2);
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = "x";
                        generatedCalculation[2] = "(";
                        generatedCalculation[3] = num2;
                        generatedCalculation[4] = "-";
                        generatedCalculation[5] = num3;
                        generatedCalculation[6] = ")";
                        var ans = num1*(num2-num3);
                    }
                    if (gcalc.topic_key == "divorder"){//multiplication order
                        var override = "divorder";
                        var ans = GenerateRandom(1,10);
                        var num1 = GenerateRandom(2,10);
                        var num2 = GenerateRandom(1,num1);
                        var num3 = ans * (num1 - num2);
                        //
                        generatedCalculation[0] = num3;
                        generatedCalculation[1] = "÷";
                        generatedCalculation[2] = "(";
                        generatedCalculation[3] = num1;
                        generatedCalculation[4] = "-";
                        generatedCalculation[5] = num2;
                        generatedCalculation[6] = ")";
                    }
                    if (gcalc.topic_key == "squares"){//cube a number
                        var override = "squares";
                        var num1 = GenerateRandom(1,10);
                        const operator = "^";
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = "²";
                        var ans = num1*num1;
                    }
                    if (gcalc.topic_key == "squares2"){//cube a number
                        var override = "squares2";
                        var num1 = GenerateRandom(1,10);
                        var num2 = GenerateRandom(1,9);
                        var ans = (num1*num1) + num2;
                        //
                        generatedCalculation[0] = num1;
                        generatedCalculation[1] = "²";
                        generatedCalculation[2] = "+";
                        generatedCalculation[3] = num2;
                    }
                    if (gcalc.topic_key == "div"){//cube a number
                        var override = "div";
                        var num1 = GenerateRandom(1,10);
                        var num2 = GenerateRandom(1,10)*num1*10;
                        var ans = num2/num1;
                        //
                        generatedCalculation[0] = num2;
                        generatedCalculation[1] = "÷";
                        generatedCalculation[2] = num1;
                    }
                    //new questions here
                    if(gcalc.topic_key == "count2")
                    {
                        var override = "count2";
                        var extraNumbers = "";
                        var num1array = [2,4,6,8,10,12,14,16];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];
                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 2;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 2s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count3")
                    {
                        var override = "count3";
                        var extraNumbers = "";
                        var num1array = [3,6,9,12,15,18,21,24];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 3;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 3s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count4")
                    {
                        var override = "count4";
                        var extraNumbers = "";
                        var num1array = [4,8,12,16,20,24,28,32];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 4;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 4s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count5")
                    {
                        var override = "count5";
                        var extraNumbers = "";
                        var num1array = [5,10,15,20,25,30,35,40];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 5;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 5s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count6")
                    {
                        var override = "count6";
                        var extraNumbers = "";
                        var num1array = [6,12,18,24,30,36,42,48];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 6;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 6s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count7")
                    {
                        var override = "count7";
                        var extraNumbers = "";
                        var num1array = [7,14,21,28,35,42,49,56];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 7;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 7s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count8")
                    {
                        var override = "count8";
                        var extraNumbers = "";
                        var num1array = [8,16,24,32,40,48,56,64];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 8;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 8s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count9")
                    {
                        var override = "count9";
                        var extraNumbers = "";
                        var num1array = [9,18,27,34,45,54,63,72];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 9;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 9s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count10")
                    {
                        var override = "count10";
                        var extraNumbers = "";
                        var num1array = [10,20,30,40,50,60,70,80];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (var y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 10;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 10s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }

                    console.log(gcalc);
                    if (override == undefined){
                        acc = [...acc, {
                            "calculation": generatedCalculation,
                            "answer": getAnswer(generatedCalculation),
                            "topic_id": gcalc.topic_id
                        }];
                    }else{
                        acc = [...acc, {
                            "calculation": generatedCalculation,
                            "answer": ans,
                            "topic_id": gcalc.topic_id
                        }];
                    }
                  
                }
                console.log(acc);
                return acc;
            }, []));
        }
        else if (loadedquestions && loadedquestions.length == 0){
            setReducedQuestions([]);
        }
    }, [loadedquestions]);

    useEffect(() => {
        
        
        if (questions && questions.length > 0) {
            if(questions[0].topic_id == 30){
                CreateDotArray(questions[0].calculation[0],questions[0].calculation[2]);
            }
            if(questions[0].topic_id == 31){
                CreateDotArray(questions[0].calculation[0],questions[0].calculation[2]);
            }
            if(questions[0].topic_id == 32){
                CreateDotArray(questions[0].calculation[0],questions[0].calculation[2]);
            }
            if(questions[0].topic_id == 33){
                CreateDotArray(questions[0].calculation[0],questions[0].calculation[2]);
            }
            if(questions[0].topic_id == 34){
                CreateDotArray(questions[0].calculation[0],questions[0].calculation[2]);
            }
            
                //setCurrentQuestion(questions[0]);
                var rndquestion = (Math.floor(Math.random() * questions.length));
                setCurrentQuestion(questions[rndquestion]);
		}    
    }, [questions]);

    useEffect(() => {
        console.log("CURRENT QUESTION:");
        console.log(currentQuestion);
        
    }, [currentQuestion]);


    function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }
  
      useEffect(() => {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else if(waitTime != -10){
    
            setColouredFeedback(false);
            newQuestion();
        }
      },[waitTime]);


    function newQuestion(){
        console.log("gen new question");
        nextQuestion = (Math.floor(Math.random() * questions.length));
        setCurrentQuestion(questions[nextQuestion]);
        console.log(questions[nextQuestion]);
        
    }


    async function checkResultMultipleChoice(value, callback) {

        //set the current question to the last question -refeed
          questionCounter = questionCounter +1;
          lastQuestion = currentQuestion.question;
          console.log("press button");
          console.log(value);
      
          var isCorrect = true;
          if (value) {
            //correct answer
            if (value.correct == true) {
              setCorrectQuestions([...correctQuestions, currentQuestion]);
              let multiplier = combo > 0 ? combo + 1 : 1;
              multiplier = multiplier > 5 ? 5 : multiplier;
              setScore(score + multiplier * 10);
      
              if (combo < 99) {
                setCombo(combo + 1);
              }
              if (combo > maxCombo) {
                setMaxCombo(combo);
              }
              //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
              if (repeating) {
                  refeedQuestions.pop();
                  repeating = false;
              }
      
              let result = {
                question: currentQuestion.question,
                correct: currentQuestion.correct,
                incorrect: value.value
            };
            setNoFeedback([...nofeedback, result]);
      
              newQuestion();
            }
            //incorrect answer
            else {
                questionCounter = 0;
              isCorrect = false;
              //push question to refeed if user gets it wrong - refeed
              refeedQuestions.push(currentQuestion);
      
              setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
              if (combo === 0 && score >= 10) {
                setScore(score - 10);
              } else {
                setCombo(0);
              }
              let result = {
                question: currentQuestion.question,
                correct: currentQuestion.correct,
                incorrect: value.value
              };
      
              setFeedback([...feedback, result]);
              setColouredFeedback(true);
              setWaitTime(2);
            }
      
            //Generates a new question
            //newQuestion();
      
          }
        }

    async function checkResult(value, callback) {
        setDotArrayOpen(false);
        showHideText = "Show Dot Array";
    //set the current question to the last question index -refeed
        questionCounter = questionCounter +1;
        lastQuestion = nextQuestion;

        var isCorrect = true;
        if (value) {
            //correct answer
            if (parseInt(currentQuestion.answer) === parseInt(value)) {
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);

                if (combo < 99) {
                    setCombo(combo + 1);
                }
                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
                if (repeating) {
                    refeedQuestions.pop();
                    repeating = false;
                }
                let result = {
                    question: currentQuestion.calculation.join(" ") + " =",
                    correct: currentQuestion.answer,
                    incorrect: value
                };
                setNoFeedback([...nofeedback, result]);
            } //incorrect answer
            else 
            {
                isCorrect = false;
                questionCounter = 0;
                //push question to refeed if user gets it wrong - refeed
                refeedQuestions.push(currentQuestion);
                console.log(refeedQuestions);

                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }

                let result = {
                    question: currentQuestion.calculation.join(" ") + " =",
                    correct: currentQuestion.answer,
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            //get nextQuestion index
            nextQuestion = (Math.floor(Math.random() * questions.length));

            //Debugging
            /*
            console.log("tst: lastQ: " + lastQuestion);
            console.log("tst: currQ: " + currentQuestion.calculation);
            console.log("tst: Counter: " + questionCounter);
            console.log(refeedQuestions[0]);

            */
            
             
             //get refeed question
            var loop = true;
            if (questionCounter === 2 && refeedQuestions[0] != undefined) {
                repeating = true;
                 questionCounter = 0;
                currQuestion = refeedQuestions[refeedQuestions.length - 1];
                 setCurrentQuestion(currQuestion);
                 loop = false;
            }
            else{
            //if the next question is index is the same as the last question index then reloop
                while(loop){
                if (nextQuestion === lastQuestion) { 
                   
                    nextQuestion = (Math.floor(Math.random() * questions.length));
                    //console.log("tst: I have looped!");
                }
                else
                {
                                    image = "";
                    if(questions[nextQuestion].topic_id == 30){
                        CreateDotArray(questions[nextQuestion].calculation[0],questions[nextQuestion].calculation[2]);
                    }
                    if(questions[nextQuestion].topic_id == 31){
                        CreateDotArray(questions[nextQuestion].calculation[0],questions[nextQuestion].calculation[2]);
                    }
                    if(questions[nextQuestion].topic_id == 32){
                        CreateDotArray(questions[nextQuestion].calculation[0],questions[nextQuestion].calculation[2]);
                    }
                    if(questions[nextQuestion].topic_id == 33){
                        CreateDotArray(questions[nextQuestion].calculation[0],questions[nextQuestion].calculation[2]);
                    }
                    if(questions[nextQuestion].topic_id == 34){
                        CreateDotArray(questions[nextQuestion].calculation[0],questions[nextQuestion].calculation[2]);
                    }
                    //console.log("tst: Good to go!");
                    loop = false; 
                    
                    break;
                }
            }
        }

            if (callback) {
                await callback(isCorrect, currentQuestion.answer).then(() => {
                    setCurrentQuestion(
                        questions[nextQuestion]
                    );
                    /*
                    setCurrentQuestion(
                        questions[Math.floor(Math.random() * questions.length)]
                    );
                    */
                });
            } else {
                setCurrentQuestion(
                    questions[nextQuestion]
                );
                    /*
                    setCurrentQuestion(
                        questions[Math.floor(Math.random() * questions.length)]
                    );
                    */
            }
        }
    }

    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {
       refeedQuestions = [];
       questionCounter = 0;
       lastQuestion = "";
       console.log("RESET");
    }

    function ComboImage(){
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.gameData.animation_path + "/combo"+comboNum+".gif";
         //return <img src= {{imageName}} style={{position:"relative"}}></img>
         return <img style={{position: "absolute",top:"40%",right:"6%"}} src={require("../../assets/"+imageName)}></img>
    }

    function ReturnImage(){
        return image;
    }

    function CreateDotArray(r,c){
        image = "";
            for(var i = 0; i < r; i++){//number of rows
                for(var j = 0; j < c; j++){//number of columns
                    var topValue = 0 + (i * 7);
                    var rightValue = 86 - (j * 4);
                    image += '<img src="' + DotArrayImage + '"' + "style='position:absolute ; top:" + topValue + "%; right:" + rightValue + "%; transform: scale(0.2,0.2);  zIndex:-1'" + '></img>'
                }
            }
    }

    function RenderElement(){
        if(dotArrayOpen){

            return <div dangerouslySetInnerHTML={{ __html: ReturnImage() }}></div>
        }

        
    }

    function ToggleArray(){
        if(dotArrayOpen == true) {
            setDotArrayOpen(false);
            showHideText = "Show Dot Array";
        } else {
            setDotArrayOpen(true);  
            showHideText = "Hide Dot Array";
        }
    }
    



    

    return (
        <PracticeGame
            parent={props}
            loading={!questions}
            correct={correctQuestions}
            incorrect={incorrectQuestions}
            score={score}
            onBack={() =>{
            Reset();
            props.onBack();
            }}
            defaultTimer={timer}
            questionLimit={questionMax}
            restart={() => {
                setCombo(0);
                setScore(0);
                setCorrectQuestions([]);
                setIncorrectQuestions([]);
                Reset();
            }}
            feedback={feedback}
            nofeedback={nofeedback}
            homework_id={props.homework_id}
        >
            <div style={{ backgroundImage: `url(${props.gameBackground})`, backgroundSize: "cover", height: "100%" }} >
                <Scale scaleTo={1720}>
                    <Body>
                    {currentQuestion != undefined && currentQuestion.version != "new" &&
                    <Calculator
                    currentQuestion={[currentQuestion.calculation, currentQuestion.answer]}
                    onSubmitted={checkResult}
                    />
                    }
                    {currentQuestion != undefined && currentQuestion.version == "new" && currentQuestion.type == "NP" &&
                    <CalculatorNew
                    currentQuestion={currentQuestion}
                    onSubmitted={checkResult}
                    />
                    }
                    {currentQuestion != undefined && currentQuestion.version == "new" && currentQuestion.type == "NPR" &&
                     <CalculatorRemainder
                     currentQuestion={currentQuestion}
                     onSubmitted={checkResult}
                     />

                    }

                    {currentQuestion != undefined && currentQuestion.questionHTML != "" && currentQuestion.type == "NP" ? (
                        <DynamicStyle >
                           <div style={{position: "fixed", right: "75%", top: "20%"}} dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}


{currentQuestion != null && currentQuestion.version == "new" && currentQuestion.type == "MC" &&
              <div style={{display: "flex", justifyContent: "center"}}>
                <Question2 style={{width: "1300px"}}>{currentQuestion.question}</Question2>
                      {(currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.questionHTML == "") ? (
                        <img src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currentQuestion.questionHTML != "" ? (
                        <DynamicStyle >
                          <div style={{position: "fixed", right: "75%", top: "20%"}} dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}

                <div style={{position: "fixed", width: "100%", right: "0%", top: "60%", display: "flex"}}>
                  {showColouredFeedback == false && currentQuestion.answers != undefined &&
                    currentQuestion.answers.map(answer => (
                      <Buttonv2
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" }}
                        onClick={() => checkResultMultipleChoice(answer, true)}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                      </Buttonv2>
                    ))}

                  {showColouredFeedback == true && currentQuestion.answers != undefined &&
                    currentQuestion.answers.map(answer => (
                      <Buttonv2
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                      </Buttonv2>
                    ))}
                    </div>
                </div>
              }
                    </Body>
                    <div>
                        {currentQuestion != null && currentQuestion.version != "new" &&
                        <Button onClick={() => ToggleArray()}>
                            {showHideText}
                        </Button>
                        }
                        {currentQuestion != null && currentQuestion.version != "new" &&
                        <div>
                        {ComboImage()}
                        </div>
                        }

                        {RenderElement()}


                    </div>
                </Scale>
            </div>
        </PracticeGame >
    );
    
}

const Body = styled.div`
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 40px;
        `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
        `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
        `;

const Button = styled.button`
            background: rgb(234, 146, 19);
            background: linear-gradient(
                0deg,
                rgba(234, 146, 19, 1) 0%,
                rgba(255, 186, 32, 1) 100%
              );
            color: #fff;
            font-size: 20px;
            padding: 10px 60px;
            border: 2px solid #e88f12;
            border-radius: 0.25em;
            margin: 10px 0px;
            cursor: pointer;
            position:absolute;
            top:15%
            right:10%
        `;

        const Question = styled.div`
        background: #FFF;
        user-select: none;
        width: 1000px;
        height: 120px;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
      `;

      const Question2 = styled.div`
        background: #FFF;
        user-select: none;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
        padding: 18px;
      `;
      const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
        position: realtive;
      top: 35%;
      //left: -15%;
      //width: 100%
      //text-align: center
      font-size 2em;
      //50%
    `;


    const Buttonv2 = styled.div`
        z-index: 1;
        text-align: center;
        height: 150px;
        line-height: 100px;
        font-size: 4em;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        padding: 0.5em;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;
